import type { LicenseHolder } from './license-holder';
import type { LicenseHolderInvite } from './license-holder-invite';

export type LicenseHolderOrInvite = LicenseHolderInvite | LicenseHolder;
export const isInvite = (holderOrInvite: LicenseHolderOrInvite): holderOrInvite is LicenseHolderInvite => {
	return 'email' in holderOrInvite;
};
